import { useState } from 'react'

import { Container, ContainerTab, Tab, Title, TitleTab } from './styles'
import { ACTIVE_HEALTH_CLAIM_APPROVAL, HealthClaimApprovalSortableFieldEnum } from './types'
import TableApproval from './components/TableApproval'
import TableSystemApproval from './components/TableSystemApproval'

const HealthClaimApprovalPage = () => {
  const [statusTab, setStatusTab] = useState<HealthClaimApprovalSortableFieldEnum>(
    HealthClaimApprovalSortableFieldEnum.APPROVAL,
  )
  return (
    <Container>
      <Title>การจัดการระดับการอนุมัติการเคลม</Title>
      <ContainerTab>
        <Tab>
          <TitleTab
            select={statusTab === HealthClaimApprovalSortableFieldEnum.APPROVAL}
            onClick={() => setStatusTab(HealthClaimApprovalSortableFieldEnum.APPROVAL)}
            data-testid="health-claim-approval-tab-approval"
          >
            {ACTIVE_HEALTH_CLAIM_APPROVAL[HealthClaimApprovalSortableFieldEnum.APPROVAL]}
          </TitleTab>
        </Tab>
        <Tab>
          <TitleTab
            select={statusTab === HealthClaimApprovalSortableFieldEnum.SYSTEM_APPROVAL}
            onClick={() => setStatusTab(HealthClaimApprovalSortableFieldEnum.SYSTEM_APPROVAL)}
            data-testid="health-claim-approval-tab-system-approval"
          >
            {ACTIVE_HEALTH_CLAIM_APPROVAL[HealthClaimApprovalSortableFieldEnum.SYSTEM_APPROVAL]}
          </TitleTab>
        </Tab>
      </ContainerTab>
      {statusTab === HealthClaimApprovalSortableFieldEnum.APPROVAL && <TableApproval />}
      {statusTab === HealthClaimApprovalSortableFieldEnum.SYSTEM_APPROVAL && (
        <TableSystemApproval />
      )}
    </Container>
  )
}

export default HealthClaimApprovalPage
